import * as React from 'react';
import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';
import { TOOLBAR_BACKCOLOR } from '@editor/src/img/pageIndex';
import { TDWActionType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';

export const config = {
    id: ActionType.BACKCOLOR,
    value: '',
    tipMsg: i18n.t('高亮文本'),
    icon: TOOLBAR_BACKCOLOR,
    twdConfig: {
        action: TDWActionType.TEXT_HIGHLINE,
    },
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        hasArrow: true,
        tooltip: config.tipMsg,
        icon: <img src={config.icon} alt={''}/>,
    },
];

export const containerId = `toolbar-button-${ActionType.BACKCOLOR}`;

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        style: {
            width: 249,
            overflow: 'hidden',
            padding: 0,
            height: 'auto',
        },
    },
];
